import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SeInventarios } from 'constants/index'

const SeInventarioTipoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO' htmlFor='select-se' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='se'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-se'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              <option value=''>Seleccionar</option>
              {SeInventarios.__array.map((val, key) => (
                <option key={key} value={val.id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SeInventarioTipoFormGroup)
